module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_vm._m(0), _c('h4', {
    staticClass: "subtitle is-3"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.tick <= 15) ? _c('span', {
    key: "1"
  }, [_vm._v("veut lire lance son algorithme.")]) : (_vm.tick <= 30) ? _c('span', {
    key: "2"
  }, [_vm._v("fouille dans ses bases de données.")]) : (_vm.tick <= 45) ? _c('span', {
    key: "3"
  }, [_vm._v("veut lire analyse le contexte du livre.")]) : (_vm.tick <= 60) ? _c('span', {
    key: "4"
  }, [_vm._v("compile les résultats.")]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title is-2"
  }, [_c('b', {
    staticClass: "white"
  }, [_vm._v("Robert")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea1a22c0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/loading.vue
// module id = 1367
// module chunks = 1